import { render, staticRenderFns } from "./delivery-target.vue?vue&type=template&id=4f9b1d75&scoped=true&"
import script from "./delivery-target.vue?vue&type=script&lang=js&"
export * from "./delivery-target.vue?vue&type=script&lang=js&"
import style0 from "./delivery-target.vue?vue&type=style&index=0&id=4f9b1d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b1d75",
  null
  
)

export default component.exports